import { fetchData, postData, putData } from "../utils/apiUtils";

export const get_project_data = async () => {
  const responseData = await fetchData("project");
  return responseData;
};

export const get_task_assignment = async () => {
  const responseData = await fetchData("employee/gigworker/task/report");
  return responseData;
};
export const get_branch_emp_task_assignment = async (branch_id) => {
  const responseData = await fetchData(
    `employee/gigworker/task/branch?branch_id=${encodeURIComponent(branch_id)}`
  );
  return responseData;
};

export const get_ekyc_lists = async (branch_id = null) => {
  let url = "employee/ekyc-device";
  if (branch_id && branch_id.trim() !== "") {
    url += `?branch_id=${encodeURIComponent(branch_id)}`;
  }
  const responseData = await fetchData(url);
  return responseData;
};

export const get_unassigned_ekyc = async (branch_id = null) => {
  let url = "employee/unassigned-ekyc-device";
  if (branch_id && branch_id.trim() !== "") {
    url += `?branch_id=${encodeURIComponent(branch_id)}`;
  }
  const responseData = await fetchData(url);
  return responseData;
};

export const RegisterEkycAssignment = async (EkycData) => {
  const responseData = await postData(
    "employee/ekyc-device-assignemnt/assign",
    EkycData
  );
  return responseData;
};

export const RegisterEKYC = async (Device) => {
  const responseData = await postData("employee/ekyc-device/register", Device);
  return responseData;
};
export const UpdateEKYC = async (Data) => {
  const responseData = await putData("employee/ekyc-device/update", Data);
  return responseData;
};
export const get_branch_ekyc_assignment = async (branch_id) => {
  const responseData = await fetchData(
    `employee/branch-ekyc-device-assignemnt?branchId=${encodeURIComponent(
      branch_id
    )}`
  );
  return responseData;
};

export const get_project_data_byId = async (id) => {
  const responseData = await fetchData(
    `project/byid?id=${encodeURIComponent(id)}`
  );
  return responseData;
};
export const get_project_jobs = async () => {
  const responseData = await fetchData("project/project_job");
  return responseData;
};
export const RegisterProject = async (projectData) => {
  const responseData = await postData("project/register", projectData);
  return responseData;
};

export const AssignProjectLabor = async (projectData) => {
  const responseData = await postData(
    "project/project_labor/register",
    projectData
  );
  return responseData;
};

export const get_project_labors = async (project) => {
  const responseData = await fetchData(
    `project/project_labor/byproject?project=${encodeURIComponent(project)}`
  );
  return responseData;
};

export const get_project_attendance_sheet = async (project) => {
  const responseData = await fetchData(
    `project/labor_attendance/sheet?project=${encodeURIComponent(project)}`
  );
  return responseData;
};

export const get_project_attendance_sheet_bydate = async (
  project,
  from,
  to
) => {
  const responseData = await fetchData(
    `project/labor_attendance/findsheet/byproject?project=${encodeURIComponent(
      project
    )}&fromdate=${encodeURIComponent(from)}&todate=${encodeURIComponent(to)}`
  );
  return responseData;
};

export const get_labor_attendance = async (project, date) => {
  const responseData = await fetchData(
    `project/labor_attendance/byproject?project=${encodeURIComponent(
      project
    )}&date=${encodeURIComponent(date)}`
  );
  return responseData;
};

export const CreateBulkAtendanceSheet = async (projectData) => {
  const responseData = await postData(
    "project/labor_attendance/bulkregister",
    projectData
  );
  return responseData;
};
export const UpdateAtendance = async (AttendanceData) => {
  const responseData = await putData(
    "project/labor_attendance/update",
    AttendanceData
  );
  return responseData;
};

export const UpdateBulkAtendance = async (AttendanceData) => {
  const responseData = await putData(
    "project/labor_attendance/bulkupdate",
    AttendanceData
  );
  return responseData;
};

// project job
export const get_project_job = async () => {
  const responseData = await fetchData(`project/project_job`);
  return responseData;
};

export const RegisterProjectJob = async (projectJob) => {
  const responseData = await postData(
    "project/project_job/register",
    projectJob
  );
  return responseData;
};

export const get_item_list = async () => {
  const responseData = await fetchData(`ims/items`);
  return responseData;
};
export const UpdateProjectJob = async (Data) => {
  const responseData = await putData("project/project_job/update", Data);
  return responseData;
};

export const RegisterEmployeeStock = async (stockData) => {
  const responseData = await postData("ims/employestock/add", stockData);
  return responseData;
};

export const EmployeeStockSell = async (Data) => {
  const responseData = await postData("ims/employestock/sell", Data);
  return responseData;
};
export const get_branch_employee_stock = async (branch = null) => {
  let url = `ims/employestock`;
  if (branch) {
    url = `${url}?branch_id=${encodeURIComponent(branch)}`;
  }
  const responseData = await fetchData(url);
  return responseData;
};

export const get_branchstock = async (branch = null) => {
  let url = `ims/branchstock`;
  if (branch) {
    url = `${url}?branch_id=${encodeURIComponent(branch)}`;
  }
  const responseData = await fetchData(url);
  return responseData;
};

export const AddBranchStock = async (Data) => {
  const responseData = await postData("ims/branchstock/add", Data);
  return responseData;
};
export const AdjustBranchStock = async (Data) => {
  const responseData = await postData("ims/branchstock/adjust", Data);
  return responseData;
};
